import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import i18n from 'i18n-react';

export interface FreeHotelProps {
  id: string;
  flyToMarker: () => void;
  hotelInfo: () => void;
  hotelName: string;
  city?: string | null;
  phone?: string | null;
  cuisine?: string | null;
  subCatname?: string | null;
  brandImageUrl?: string | null;
  segmentImageUrl?: string | null;
}

export function FreeHotel({
  id,
  flyToMarker,
  hotelInfo,
  hotelName,
  city,
  phone,
  cuisine,
  subCatname,
  brandImageUrl,
  segmentImageUrl,
}: FreeHotelProps) {
  return (
    <div className="freeDiv" id={id}>
      <div className="iconDiv">
        <span
          className="fa-layers fa-fw fa-2x markerCircle"
          onClick={flyToMarker}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              flyToMarker();
            }
          }}
          role="button"
          tabIndex={0}
          aria-label={i18n.translate('directoryView.viewOnMap') as string}
          key="map"
        >
          <FontAwesomeIcon icon={['fas', 'circle']} className="circle" />
          <FontAwesomeIcon icon={['fas', 'map-marker-alt']} className="marker" />
        </span>
      </div>
      <div className="freeInfoDiv" onClick={hotelInfo}>
        <div className="content">
          {brandImageUrl && <img className="freeHotelImg logo-top" src={brandImageUrl} alt={`${hotelName} brand logo`} />}
          <span className="freeHotelName">{hotelName}</span> <br />
          <span className="freeHotelAddr">{city}</span> <br />
          <span className="free-hotel-detail">{phone}</span> <br />
          {cuisine && (
            <span className="free-hotel-detail">
              {cuisine} <br />
            </span>
          )}
          {subCatname && (
            <span className={clsx('free-hotel-detail', 'free-hotel-detail--small')}>
              {subCatname} <br />
            </span>
          )}
          {segmentImageUrl && <img className="freeHotelImg logo-bottom" src={segmentImageUrl} alt={`${hotelName} segment logo`} />}
          <br />
          <span className="moreInfo">{i18n.translate('directoryView.viewNow')}</span>
          <br />
          <br />
        </div>
      </div>
    </div>
  );
}
